import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

/**
 * Height of the card heading: the icon box and the title's line box are both this
 * tall, and the heading action matches so the row reads as one line.
 */
const HEADING_HEIGHT = 24

export const useStyles = makeStyles()(() => ({
  card: {
    boxSizing: 'border-box',
    width: '100%',
    backgroundColor: C.cardBg,
    borderRadius: 8,
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
  },
  // The shared outlined button restyled to the Figma AI action (node 1421:5546):
  // white, pink border, gradient sparkles, small dark label.
  createBtn: {
    // Pushes the action to the far end of the heading row.
    marginLeft: 'auto',
    flexShrink: 0,
    // The shared button's own class sets its box and colors, so the override
    // has to outrank it rather than sit beside it.
    '&.MuiButton-root': {
      boxSizing: 'border-box',
      minHeight: 0,
      height: 'auto',
      padding: '4px 8px',
      gap: 4,
      backgroundColor: C.cardBg,
      border: `1px solid ${C.todoPillBorder}`,
      borderRadius: 8,
      color: C.darkText,
      fontSize: 11,
      fontWeight: 500,
      lineHeight: '16px',
      letterSpacing: 0.5,
      textTransform: 'none',
      whiteSpace: 'nowrap',
      '& .MuiButton-startIcon': {
        margin: 0,
      },
    },
  },
  createIcon: {
    width: 12,
    height: 12,
  },
  iconBox: {
    width: HEADING_HEIGHT,
    height: HEADING_HEIGHT,
    borderRadius: 4,
    backgroundColor: C.iconBoxBg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {
      fontSize: 12,
      color: C.darkText,
    },
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: C.darkText,
    margin: 0,
  },
  metrics: {
    display: 'flex',
    gap: 12,
    width: '100%',
  },
  metric: {
    position: 'relative',
    boxSizing: 'border-box',
    flex: '1 0 0',
    minWidth: 0,
    backgroundColor: C.metricBg,
    border: `1px solid ${C.metricBorder}`,
    boxShadow: C.metricShadow,
    borderRadius: 8,
    padding: '8px 12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 2,
    font: 'inherit',
    textAlign: 'left',
    cursor: 'pointer',
    '&:disabled': {
      cursor: 'default',
    },
  },
  askAiIconWrap: {
    position: 'absolute',
    right: 12,
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    visibility: 'hidden',
    'button:hover:not(:disabled) &': {
      visibility: 'visible',
    },
  },
  askAiIcon: {
    width: 16,
    height: 16,
  },
  metricLabel: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '18px',
    margin: 0,
    whiteSpace: 'nowrap',
    padding: '2px 8px',
    borderRadius: 999,
  },
  approved: {
    backgroundColor: C.approvedPillBg,
    color: C.approvedPillText,
  },
  pending: {
    backgroundColor: C.pendingPillBg,
    color: C.pendingPillText,
  },
  potential: {
    backgroundColor: C.potentialPillBg,
    color: C.potentialPillText,
  },
  valueRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  count: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: '27px',
    letterSpacing: '-0.26px',
    color: C.valueText,
    margin: 0,
  },
  divider: {
    width: 1,
    height: 22,
    backgroundColor: C.divider,
    flexShrink: 0,
  },
  amountGroup: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: 2,
  },
  currency: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '23px',
    color: C.mutedText,
    margin: 0,
  },
  amount: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: '27px',
    color: C.darkText,
    margin: 0,
    whiteSpace: 'nowrap',
  },
}))
